import { OnChanges, SimpleChanges, SimpleChange, Component, OnInit, OnDestroy, Output, Input, EventEmitter } from '@angular/core';
import {OptionsserviceService, LoansService, StorageService, DataService} from '../_services/index';
import { Loan } from '../_interfaces/loan.interface';
import { Loan_ } from '../_models/loan_';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-loanrepayment',
  templateUrl: './loanrepayment.component.html',
  styleUrls: ['./loanrepayment.component.css']
})
export class LoanrepaymentComponent implements OnInit, OnChanges {
  OPEN_SCHEDULE = false;
  @Input('from_where') from_where = '1';
  public schedule: any;
  @Input('parentRouteId') parentRouteId: number;
  @Input('where') where = '1';
  request_id_: any;
  public sub: any;
  public loading = false;
  @Input('currentUser') currentUser: any;
  public status = false;
  @Output() closePopUp = new EventEmitter();
  @Output() modifyContract = new EventEmitter();
  canEditSchedule = false;
  loan_status:any;
  constructor(public route: ActivatedRoute, public storageService: StorageService,
    public optionsService: OptionsserviceService, public loansService: LoansService, public dataService: DataService) {
      this.currentUser = this.storageService.read<any>('currentUser');
      this.dataService.contractHasBeenCreated.subscribe(res => {
        this.getAllSchedule();
      })
  }
  saveNewRepayment() {
    this.loading = true;
    this.loansService.saveNewRepayment(this.currentUser.token, this.parentRouteId, this.schedule)
      .subscribe(analysis => {
        this.loading = false;
        this.getAllSchedule();

      });
  }
  ngOnInit() {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.getAllSchedule();
  }
  ngOnChanges(changes: SimpleChanges) {
    const parentRouteId: SimpleChange = changes.parentRouteId;
    if (parentRouteId.currentValue) {
      this.request_id_ = parentRouteId.currentValue;
      this.getAllSchedule()
    }

  }
  getAllSchedule() {
    if (this.where == '1') {
      this.sub = this.route.parent.params.subscribe(params => {
        this.parentRouteId = +params["id"];
        this.loansService.getLoanSchedule(this.currentUser.token, this.parentRouteId)
          .subscribe(repayments => {
            this.status = repayments.status;
            if (repayments.status) {
              this.schedule = repayments.data;
              this.canEditSchedule = repayments.can_modify_contract;
            } else {

            }

          });
      });
    } else {
      this.loansService.getLoanRepaymentsSchedule(this.currentUser.token, this.parentRouteId)
        .subscribe(repayments => {
          this.status = repayments.status;
          if (repayments.status) {
            this.schedule = repayments.data;
            this.canEditSchedule = repayments.can_modify_contract;
            this.loan_status = repayments.loan_status;
          } else {

          }

        });
    }
  }
  getTotal(key, schedule) {
    if (schedule === undefined) { } else {
      let total = 0;
      if (key === "INITIAL_PRINCIPAL") {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.INITIAL_PRINCIPAL); }, 0);
      }
      if (key === "PRINCIPAL_REPAYMENT") {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.PRINCIPAL_REPAYMENT); }, 0);
      }
      if (key === "INTEREST_REPAYMENT") {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.INTEREST_REPAYMENT); }, 0);
      }
      if (key === "FEES") {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.FEES) + parseInt(o.VAT_ON_FEES); }, 0);
      }
      if (key === "TERM_REPAYMENT") {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.TERM_REPAYMENT); }, 0);
      }
      return total;
    }
    //

  }
  closeTheLoanFormPopUp() {
    this.closePopUp.emit();
  }
  modifyTheContract() {
    this.modifyContract.emit();
  }
  showFullView() {
    this.dataService.showScheduleDetails.emit({request_id:this.parentRouteId,loan_status: this.loan_status, schedule: this.schedule, canEditSchedule:this.canEditSchedule});
  }
}
